import { useState } from "react";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { ModalAmenities } from "./ModalAmenities";

type Props = {
  amenities: string[];
};

export const ListingStayDetailAmenities = ({ amenities }: Props) => {
  const [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);

  function closeModalAmenities() {
    setIsOpenModalAmenities(false);
  }

  function openModalAmenities() {
    setIsOpenModalAmenities(true);
  }
  return (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">O que esse hotel oferece</h2>
      </div>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
        {amenities
          .filter((_, i) => i < 12)
          .map((item) => (
            <div key={item} className="flex items-center space-x-3">
              <span>{item}</span>
            </div>
          ))}
      </div>

      <div className="w-14 border-b border-neutral-200" />

      <div>
        <ButtonSecondary onClick={openModalAmenities}>
          Ver todas as {amenities.length} comodidades
        </ButtonSecondary>
      </div>

      <ModalAmenities
        amenities={amenities}
        closeModalAmenities={closeModalAmenities}
        isOpenModalAmenities={isOpenModalAmenities}
      />
    </div>
  );
};
